import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const document = inject(DOCUMENT);
    const localStorage = document.defaultView?.localStorage;
    if (!localStorage || localStorage.getItem('TheToken') === null) {
      return next.handle(request);
    }
    let req = request.clone({
      setHeaders: { Authorization: `Bearer ${localStorage.getItem('TheToken')}` },
    });
    return next.handle(req);
  }
}
